import { ChangeDetectionStrategy, Component, input, model } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';

let nextId = 0;

@Component({
	selector: 'xp-expander',
	standalone: true,
	imports: [MatIconModule],
	templateUrl: './xp-expander.component.html',
	styleUrls: ['./xp-expander.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class XpExpanderComponent {
	heading = input('');
	expanded = model(false);

	readonly bodyId = `xp-expander-body-${nextId++}`;

	toggle(): void {
		this.expanded.update(isExpanded => !isExpanded);
	}
}
